import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock'
import { faShareAlt } from '@fortawesome/pro-solid-svg-icons/faShareAlt'
import { useTranslation } from 'next-i18next'
import Icon from '@/components/icons/Icon'

const ProjectTagsStyled = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'inline'
})<{ inline?: boolean }>(({ inline }) => ({
  position: inline ? 'relative' : 'absolute',
  top: inline ? 'auto' : 9,
  left: inline ? 'auto' : 9
}))

const ProjectTagStyled = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'compact'
})<{ compact?: boolean }>(({ theme, compact }) => ({
  background: theme.palette.grey[450],
  color: theme.palette.common.white,
  textTransform: 'uppercase',
  fontSize: '10px',
  letterSpacing: '0.02em',
  padding: '3px 6px',
  height: compact ? '20px' : 'auto',
  borderRadius: '3px',
  '& .MuiChip-icon': {
    marginLeft: 0,
    marginRight: compact ? 0 : '4px',
    fontSize: '10px',
    color: theme.palette.common.white
  },
  '& .MuiChip-label': {
    display: compact ? 'none' : null,
    padding: 0
  }
}))

interface ProjectTagProps {
  title: string
  icon?: React.ReactElement
  compact?: boolean
}

const ProjectTag = ({ title, icon, compact }: ProjectTagProps): React.ReactElement => {
  return <ProjectTagStyled label={title} icon={icon} compact={compact} size="small" />
}

interface ProjectTagsProps {
  isPrivate?: boolean
  isShared?: boolean
  inline?: boolean
  compact?: boolean
}

export const ProjectTags = ({ isPrivate, isShared, inline, compact }: ProjectTagsProps): React.ReactElement => {
  const { t } = useTranslation('projects')

  return (
    <ProjectTagsStyled spacing={1} direction="row" inline={inline}>
      {isPrivate && <ProjectTag title={t('private')} icon={<Icon icon={faLock} size="sm" />} compact={compact} />}
      {isShared && <ProjectTag title={t('shared')} icon={<Icon icon={faShareAlt} size="sm" />} compact={compact} />}
    </ProjectTagsStyled>
  )
}
